import { DrawerModal } from '@fagmobler/ui';
import RefinementList from './RefinementList';
import { StockFilter } from './StockFilter';
import PriceFilter from './PriceFilter';
// import Sorting from './Sorting';
import { TagsFilter } from './TagsFilter';

export type DefaultProductFiltersProps = {
  children?: never;
  isOpen: boolean | 'sort';
  onClose: () => void;
};

export const DefaultProductFilters = ({
  onClose,
  isOpen,
}: DefaultProductFiltersProps) => {
  return (
    <DrawerModal
      isOpen={!!isOpen}
      onClose={onClose}
      title="Filtrer treff"
      unmount={false}
    >
      <div className="px-6">
        <RefinementList attribute="colour" label="Farge" />
        <RefinementList attribute="serie" label="Serie" />
        {/* <RefinementList attribute="material" label="Stoff og material" /> */}
        <PriceFilter />
        <StockFilter />
        <TagsFilter
          attribute="tags"
          operator="and"
          sortBy={['name:asc']}
          // getText={(item) => {
          //   if (item.value === 'Medlemstilbud') {
          //     return 'Vis bare produkt for medlemmer';
          //   }
          //   if (item.value === 'nyhet') {
          //     return 'Vis kun nye produkter';
          //   }
          //   if (item.value === 'bestselger') {
          //     return 'Vis kun de meste populære produktene';
          //   }

          //   if (item.value === 'KUPP!') {
          //     return 'Vis bare produkt på salg';
          //   }
          //   return item.value;
          // }}
          // transformItems={(items) =>
          //   items
          //     .filter((item) => item.label !== 'bestselger')
          //     .map((item) => {
          //       return {
          //         ...item,
          //         label:
          //           item.label.charAt(0).toUpperCase() + item.label.slice(1),
          //       };
          //     })
          // }
        />
      </div>
    </DrawerModal>
  );
};

export default DefaultProductFilters;
